import { useTranslation } from 'react-i18next'
import { useStyletron } from 'baseui'
import { ChevronLeft, ChevronRight } from 'baseui/icon'
import { useRightPanel } from './rightPanelContext'

const useRightPanelToggle = () => {
  const { t } = useTranslation()
  const [, theme] = useStyletron()
  const { expanded, toggle } = useRightPanel()

  return {
    expanded,
    onToggle: toggle,
    Icon: expanded ? ChevronRight : ChevronLeft,
    iconColor: theme.colors.primary,
    label: t(expanded ? 'common:collapse_panel' : 'common:expand_panel'),
  }
}

export default useRightPanelToggle
